<elcia-title [title]="'entity.timesheets' | translate" [iconType]="'clock'"/>
<elcia-tabs [items]="items"/>
<router-outlet></router-outlet>
